import React, { Component } from 'react';
import axios from 'axios'
import { pythonApiIp } from '../../../../config/constants'
import { Button, Divider, } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants';

class MarkProjectPayNow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commAmount: '',
        }
    }

    componentDidMount() {
        console.log("commx1 MarkProjectPayNow ++++ componentDidMount");


    }

    sendMarkProjectPayNow = () => {
        console.log("++++++++:sendMarkProjectPayNow");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)

        console.log("sending data..");

        this.setState({ loading: true });

        axios.post(pythonApiIp + 'markProjectPayNow', {
            apiKey: "APODFASF@dDFDD",
            projectId: this.props.projectId,
            enteredBy: this.props.user.email,
        })
            .then((response) => {
                this.setState({
                    loading: false
                })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. project marked as payNow");

                    alert(response.data.message);
                    //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                } else {
                    console.log("FAILED");
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    render() {

        const markPayNowButton = this.props.user.email == 'ivanmworozi@gmail.com'
            ? <div>
                <Divider horizontal>{'MARK PAYNOW'}</Divider>
                <Button onClick={this.sendMarkProjectPayNow}>MARK PAY NOW</Button>
            </div>

            : ''

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>

            {markPayNowButton}

        </div>);
    }
}

export default MarkProjectPayNow;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/MarkProjectPayNow.js